<template>
  <i v-if="icon" :class="iconClass" :style="iconStyle" />
</template>

<script>
import isValidCssColor from "@/utils/validate/isCssColor";

export default {
  name: "EgIcon",

  props: {
    /**
     * Icon color
     */
    color: {
      type: String,
      default: "currentColor",
      validator(value) {
        return (
          ["primary", "secondary", "danger", "warning", "success"].includes(
            value
          ) || isValidCssColor(value)
        );
      },
    },

    /**
     * Icon size
     */
    size: {
      type: String,
      default: "medium",
      validator(value) {
        return ["extra-small", "small", "medium", "large"].includes(value);
      },
    },

    /**
     * Icon css class
     */
    icon: {
      type: String,
      default: "",
    },
  },

  computed: {
    iconClass() {
      return `eg-icon eg-icon-${this.icon} eg-icon_color-${this.color} eg-icon_size-${this.size}`;
    },

    iconStyle() {
      let color;

      switch (this.color) {
        case "primary":
          color = "#FFFFFF";
          break;
        case "secondary":
          color = "var(--secondary)";
          break;
        case "danger":
          color = "var(--danger)";
          break;
        case "warning":
          color = "var(--warning)";
          break;
        case "success":
          color = "var(--success)";
          break;
        default:
          color = this.color;
      }

      return { color };
    },
  },
};
</script>

<style>
.eg-icon {
  font-size: 20px;
}

.eg-icon_size-extra-small {
  font-size: 12px;
}

.eg-icon_size-small {
  font-size: 16px;
}

.eg-icon_size-medium {
  font-size: 20px;
}

.eg-icon_size-large {
  font-size: 24px;
}
</style>
